<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-toolbar color="primary" dark>
            Users
            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon dark v-bind="attrs" v-on="on">mdi-information-variant</v-icon>
              </template>
              <p>
                ToolTip!
              </p>
            </v-tooltip>-->
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              label="Search"
              single-line
              hide-details
              prepend-icon="mdi-magnify"
              clearable
            ></v-text-field>
          </v-toolbar>
          <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          />
          <v-card-text v-if="users">
            <v-row>
              <v-col cols="12" class="my-0 py-0 pl-6">
                *Double click row to open
              </v-col>

              <v-col
                class="mt-0 pt-0"
                style="height: calc(100vh - 300px) !important"
                cols="12"
              >
                <agGrid
                  :agGridData="users"
                  :agGridDataLoading="usersLoading"
                  :columnDefs="columnDefs"
                  :search="search"
                  :searchTimeout="100"
                  @cellDoubleClick="viewDetails"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="newDialog" persistent max-width="600px">
      <v-card tile>
        <v-toolbar color="primary" dark>
          New User
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            icon
            dark
            @click="
              newDialog = false;
              newFormData = {
                role: 'customer',
              };
              viewFormData = {};
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form ref="newUserForm">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="newFormData.username"
                  label="Username"
                  :rules="[(v) => !!v || 'Username is Required']"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="newFormData.email"
                  label="Email Address"
                  :rules="[
                    (v) => !!v || 'Email is required',
                    (v) => /.+@.+/.test(v) || 'Email must be valid',
                  ]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="newFormData.name"
                  label="Name"
                  :rules="[(v) => !!v || 'Name is required']"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="newFormData.role"
                  label="Role"
                  :items="roles"
                  item-text="name"
                  item-value="value"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="
              create();
              viewFormData = {};
            "
            :loading="createLoading"
            text
            color="primary"
          >
            <v-icon class="pr-2">mdi-plus</v-icon>
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="viewDetailsDialog" persistent max-width="600px">
      <v-card tile>
        <v-toolbar color="primary" dark>
          User
          <v-btn
            class="editDialogButton ml-1"
            color="white"
            icon
            dark
            @click="toggleEditMode()"
          >
            <v-icon v-if="!editMode" class="editDialogIcon">mdi-pencil</v-icon>
            <v-icon v-else class="editDialogIcon">mdi-close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            icon
            dark
            @click="
              viewDetailsDialog = false;
              revertUnsavedChanged();
              newFormData = {
                role: 'customer',
              };
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form ref="editForm">
            <v-row>
              <v-col cols="12">
                <div style="margin: auto">
                  <v-btn
                    block
                    class="btn v-btn"
                    outlined
                    color="primary"
                    @click="resetTemporaryPassword()"
                  >
                    Reset Temporary Password
                  </v-btn>
                  <p class="mb-0">
                    * This will give the user a new Temporary password, and send
                    them an email with the new login details
                  </p>
                </div>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="viewFormData.username"
                  label="Username"
                  :rules="[(v) => !!v || 'Username is Required']"
                  :readonly="true"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="viewFormData.email"
                  label="Email Address"
                  :rules="[
                    (v) => !!v || 'Email is required',
                    (v) => /.+@.+/.test(v) || 'Email must be valid',
                  ]"
                  :readonly="!editMode"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="viewFormData.name"
                  label="Name"
                  :readonly="!editMode"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="viewFormData.role"
                  label="Role"
                  :items="roles"
                  item-text="name"
                  item-value="value"
                  :readonly="!editMode"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="viewFormData.toggl_apiKey"
                  label="Toggl Api Key"
                  :readonly="!editMode"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="editMode"
            @click="
              save();
              newFormData = {
                role: 'customer',
              };
            "
            :loading="saveLoading"
            text
            color="primary"
          >
            <v-icon class="pr-2">mdi-content-save-all</v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<script>
  import agGrid from "@/components/agGrid";
  import expandedToolbar from "@/components/expandedToolbar";
  import { mapGetters } from "vuex";

  export default {
    components: {
      agGrid,
      expandedToolbar,
    },
    computed: {
      ...mapGetters([
        "currentUser",
        "selectedRowData",
        "aGGridActionMenu",
        "users",
        "usersLoading",
      ]),
    },
    data: () => ({
      // AG Grid
      columnDefs: [
        // {
        //   headerName: "Actions",
        //   field: "actions",
        //   cellRendererFramework: "agGridActionButton",
        // },
        {
          headerName: "Username",
          field: "username",
        },
        {
          headerName: "Name",
          field: "name",
        },
        {
          headerName: "Email",
          field: "email",
        },
        {
          headerName: "Role",
          field: "role",
          valueFormatter: roleFormatter,
        },
        {
          headerName: "Created At",
          field: "created_at",
          valueFormatter: created_atFormatter,
        },
        {
          headerName: "Updated At",
          field: "updated_at",
          valueFormatter: updated_atFormatter,
        },
      ],
      search: "",

      // Create
      newDialog: false,
      roles: [
        {
          name: "Admin",
          value: "Admin",
        },
      ],
      newFormData: {
        role: "customer",
      },
      createLoading: false,

      // View and Edit
      viewFormData: {},
      saveLoading: false,
      editMode: false,
      viewDetailsDialog: false,

      // Link User
      linkUserDialog: false,

      // Unlink User
      unlinkUserDialog: false,

      //Google Autocomplete
      address: "",
    }),
    beforeCreate() {
      this.$store.dispatch("loadUsers");
    },
    mounted() {
      if (this.aGGridActionMenu == true) {
        this.$store.dispatch("setAGGridActionMenuState", {});
      }
    },
    methods: {
      viewDetails() {
        this.viewFormData = {};
        // NESTED DATA WONT WORK WITH .assign JSON.parse(JSON.stringify(obj)); for Nested Data
        Object.assign(this.viewFormData, this.selectedRowData);

        this.viewDetailsDialog = true;
        this.editMode = false;
      },
      revertUnsavedChanged() {
        this.editMode = false;
      },
      toggleEditMode() {
        this.editMode = !this.editMode;
      },
      resetTemporaryPassword() {
        this.$swal({
          title: "Warning",
          text:
            "Resetting a Temporary password will delete the users current password.",
          type: "warning",
          confirmButtonText: "Reset Password",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then((res) => {
          if (res.value) {
            this.$store.dispatch("resetUserTempPassword", {
              id: this.viewFormData.id,
              username: this.viewFormData.username,
            });
            this.$swal({
              title: "Success",
              text: "The user has been emailed their new Temporary password",
              type: "success",
              confirmButtonText: "Ok",
            });
          }
        });
      },
      create() {
        this.createLoading = true;
        this.$store.dispatch("newUser", this.newFormData).then((result) => {
          this.createLoading = false;
          console.log(result);
          if (result.Result == "Success") {
            this.newDialog = false;
            this.address = "";
            this.newFormData = {
              role: "customer",
            };

            this.$swal({
              title: "Success!",
              text: result.Response.Message,
              type: "success",
              confirmButtonText: "Ok",
            });
          } else {
            this.$swal({
              title: "Error!",
              text: result.Response.Message,
              type: "error",
              confirmButtonText: "Ok",
            });
          }
        });
      },
      save() {
        this.saveLoading = true;
        this.$store.dispatch("saveUser", this.viewFormData).then((result) => {
          this.saveLoading = false;
          this.editMode = false;
          console.log(result);
          if (result.Result == "Success") {
            this.address = "";
            this.$swal({
              title: "Success!",
              text: "The User Successfully Saved",
              type: "success",
              confirmButtonText: "Ok",
            });
          } else {
            this.$swal({
              title: "Error!",
              text: "There was an Error, Please try again later",
              type: "error",
              confirmButtonText: "Ok",
            });
          }
        });
      },
    },
  };
</script>
